import React from "react";

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlayersStatisticsTableRowValueViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/values/players-statistics.table.row.value.view-model";
// import classnames from "classnames";
// import styles from "../../styles/box-scores-widget.module.scss";
import {BoxScoresWidgetTableStatsCellsValue} from "./box-scores-widget.table-stats.cells.value";

class BoxScoresWidgetTableStatsCellsValuesProps extends BaseProps {
  values: Array<PlayersStatisticsTableRowValueViewModel>;
  className: String;
  emptyCell: String;
  showAllStats: Boolean;
  shouldRenderEmptyState: Boolean;
  emptyStateText: String;
  rowNum: Number;
}

export const BoxScoresWidgetTableStatsCellsValues = (({values, className, rowNum, emptyCell}: BoxScoresWidgetTableStatsCellsValuesProps) => {
  return values?.map((value: PlayersStatisticsTableRowValueViewModel, index) => <div key={rowNum + ' ' + index}
                                                                                      className={className}><BoxScoresWidgetTableStatsCellsValue value={value} emptyCell={emptyCell}/></div>)

});
